import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReportFilterReport014Service {

  constructor() {
  }

  static generate(filters: any, afilters: any[]) {
  }

}
